// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"src-components-project-project-mobile----project-mobile-module---wrapper---vnQ4M","deviceWrapper":"src-components-project-project-mobile----project-mobile-module---deviceWrapper---kcbNU","outerWrapper":"src-components-project-project-mobile----project-mobile-module---outerWrapper---c7_vP"};


//////////////////
// WEBPACK FOOTER
// ./src/components/project/project-mobile/project-mobile.module.css
// module id = 528
// module chunks = 140935043865547